// extracted by mini-css-extract-plugin
module.exports = {"heroBg":"Hero_heroBg__SUSe8","typewriter":"Hero_typewriter__GUHw3","cursor":"Hero_cursor__rTLcl","blink":"Hero_blink__ppOvm"};